import {
    getData,
    store,
} from '@/store/api/WadekController'
import {
    update,
    changeRole
} from '@/store/api/KaprodiController'
const initialState = () => ({
    wadek: {last_page: 0,data: [], total: 0},
    response: {},
    request:{
        page: 1,
        show: 10,
        sortBy: "created_at",
        sorting: "DESC",
        search: null
    },
})
const state = initialState
const getters = {
    getWadek: state => state.wadek,
    getResponse: state => state.response,
    getRequest: state => state.request
}

const actions = {
    async getData({commit }, request) 
    {
        try {
            state.request = request
            var response = await getData(request);
            commit('SET_DATA', response.data);
        } catch (_) {
            commit('SET_FAILED')
        }
    },
    async store({commit }, data) 
    {
        try {
            var response = await store(data);
            commit('SET_RESPONSE', response.data);
        } catch (_) {
            commit('SET_FAILED')
        }
    },
    async update({commit }, {data, id}) 
    {
        try {
            var response = await update(data, id);
            commit('SET_RESPONSE', response.data);
        } catch (_) {
            commit('SET_FAILED')
        }
    },
    async changeRole({commit }, {data, id}) 
    {
        try {
            var response = await changeRole(data, id);
            commit('SET_RESPONSE', response.data);
        } catch (_) {
            commit('SET_FAILED')
        }
    },
}

const mutations = {
    SET_FAILED(state) {
        state.response = {
            msg: 'Jaringan Bermasalah',
            status: '0'
        }
    },
    SET_RESPONSE(state, response){
        state.response = {
            msg: response.msg,
            status: response.status
        }
    },
    SET_DATA(state, response){
        state.response = {
            msg: response.msg,
            status: response.status
        }
        state.wadek = response.data
    },
    resetState (state) {
        const initial = initialState()
        Object.keys(initial).forEach(key => { state[key] = initial[key] })
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}